import { createApp } from "vue";
import App from "./App.vue";

// Global Components
import {
  ElRow,
  ElCol,
  ElForm,
  ElFormItem,
  ElInput,
  ElSelect,
  ElOption,
  ElRadio,
  ElRadioGroup,
  ElRadioButton,
  ElUpload,
  ElDialog,
  ElCollapse,
  ElCollapseItem,
} from "element-plus";
import "element-plus/dist/index.css";
import NeoButton from "@/components/Base/NeoButton";

// SCSS
import "@/assets/scss/main.scss";
import router from "./router";

// Mixins
import mixins from "./mixins";

// Define CreateApp
const app = createApp(App);

app.mixin(mixins);

app.use(ElRow);
app.use(ElCol);
app.use(ElForm);
app.use(ElFormItem);
app.use(ElInput);
app.use(ElSelect);
app.use(ElOption);
app.use(ElRadio);
app.use(ElRadioGroup);
app.use(ElRadioButton);
app.use(ElUpload);
app.use(ElDialog);
app.use(ElCollapse);
app.use(ElCollapseItem);

app.component("neo-button", NeoButton);

app.use(router);

app.mount("#app");
